import {NotificationTemplate} from "@/notification-template/interfaces";

const NotificationTemplateService = () => {
    return {
        /**
         * Check if a template is of type RCS (either 'rcs' or 'rcs_flow').
         */
        isRcsType(template: NotificationTemplate): boolean {
            return ['rcs', 'rcs_flow'].includes(template.type);
        }
    };
};

export default NotificationTemplateService();
